/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-ts 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { Method, RequestBodyType, ResponseBodyType, RequestConfig, RequestFunctionRestArgs, FileData, prepare } from '@bigo/yapi-to-ts'
// @ts-ignore
import request from './request'
// @ts-ignore
import makeRequestHook from './makeRequestHook'

// makeRequest
function makeRequest<TReqeustData, TResponseData>(requestConfig) {
  const req = function (requestData?: TReqeustData, options?: Record<string, any>) {
    return request<TResponseData>(prepare(Object.assign(requestConfig, options), requestData))
  }
  req.requestConfig = requestConfig
  return req
}

const mockUrl_1_0_0_0 = 'http://yapi.ppx520.com/mock/9376' as any
const dataKey_1_0_0_0 = 'data' as any

export interface Act_75352AgentQueryAnchorList9376Request {
  activityId: string
  anchorBigoId?: string
  pageIndex: string
  pageSize: string
}

export interface Act_75352AgentQueryAnchorList9376Response {
  list: {
    uid: number
    id: string
    nickName: string
    avatar: string
    signStatus: number
  }[]
  total: number
}
type Act_75352AgentQueryAnchorList9376RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/9376',
    '/bigo_act_75352_api/act_75352/agent/query_anchor_list',
    'data',
    string,
    'activityId' | 'anchorBigoId' | 'pageIndex' | 'pageSize',
    false
  >
>

const act_75352AgentQueryAnchorList9376RequestConfig = {
  mockUrl: mockUrl_1_0_0_0,
  path: '/bigo_act_75352_api/act_75352/agent/query_anchor_list',
  isYapi: true,
  isC: false,
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_1_0_0_0,
  paramNames: [],
  queryNames: ['activityId', 'anchorBigoId', 'pageIndex', 'pageSize'],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'act_75352AgentQueryAnchorList9376',
}

export const act_75352AgentQueryAnchorList9376 = makeRequest<
  Act_75352AgentQueryAnchorList9376Request,
  Act_75352AgentQueryAnchorList9376Response
>(act_75352AgentQueryAnchorList9376RequestConfig)
export const useAct_75352AgentQueryAnchorList9376 = makeRequestHook<
  Act_75352AgentQueryAnchorList9376Request,
  Act_75352AgentQueryAnchorList9376RequestConfig,
  ReturnType<typeof act_75352AgentQueryAnchorList9376>
>(act_75352AgentQueryAnchorList9376)

export interface Act_75352AgentSign9376Request {
  type: number
  activityId: number
  version: number
  /**
   * [""]
   */
  bigoIdList: string[]
  answerInfos: {
    key: string
  }
  /**
   * [{"id":0,"type":0,"title":"","isRequired":0,"hasOtherOption":0,"options":[{"num":0,"content":""}],"dayRows":[""],"timeColumns":[""],"anchorLimit":0,"stageLimit":0}]
   */
  questions: {
    id: number
    type: number
    title: string
    isRequired: number
    hasOtherOption: number
    /**
     * [{"num":0,"content":""}]
     */
    options: {
      num: number
      content: string
    }[]
    /**
     * [""]
     */
    dayRows: string[]
    /**
     * [""]
     */
    timeColumns: string[]
    anchorLimit: number
    stageLimit: number
  }[]
}

export interface Act_75352AgentSign9376Response {
  id: string
  multiActReminders: {
    bigoId: string
    activityName: string
    actId: number
    roundTime: string
  }[]
  failedList: {
    failCode: number
    bigoId: string
  }[]
  successCount: number
}
type Act_75352AgentSign9376RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/9376',
    '/bigo_act_75352_api/act_75352/agent/sign',
    'data',
    string,
    string,
    false
  >
>

const act_75352AgentSign9376RequestConfig = {
  mockUrl: mockUrl_1_0_0_0,
  path: '/bigo_act_75352_api/act_75352/agent/sign',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_1_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'act_75352AgentSign9376',
}

export const act_75352AgentSign9376 = makeRequest<Act_75352AgentSign9376Request, Act_75352AgentSign9376Response>(
  act_75352AgentSign9376RequestConfig,
)
export const useAct_75352AgentSign9376 = makeRequestHook<
  Act_75352AgentSign9376Request,
  Act_75352AgentSign9376RequestConfig,
  ReturnType<typeof act_75352AgentSign9376>
>(act_75352AgentSign9376)

export interface Act_75352AgentSignRecordPage9376Request {
  bigoId?: string
  /**
   * 格式 yyyy-MM-dd hh:mm:ss
   */
  startTime: string
  /**
   * 格式 yyyy-MM-dd hh:mm:ss
   */
  endTime: string
  /**
   * 用户手机电脑的时区, 格式举例-8,-6.5,0,+6.5,+8
   */
  zone: string
  activityName?: string
  signStatus: string
  lastId: string
  pageSize: string
}

export interface Act_75352AgentSignRecordPage9376Response {
  lastId: string
  total: number
  recordList: {
    id: string
    avatar: string
    nickname: string
    bigoId: string
    activityId: number
    signTime: number
    actStartTime: string
    actEndTime: string
    activityName: string
    roundTimeZone: string
    roundItems:
      | []
      | [
          {
            roundStartTime: string
            roundEndTime: string
            roundTimeZone: string
          },
        ]
    status: number
  }[]
}
type Act_75352AgentSignRecordPage9376RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/9376',
    '/bigo_act_75352_api/act_75352/agent/sign_record_page',
    'data',
    string,
    'bigoId' | 'startTime' | 'endTime' | 'zone' | 'activityName' | 'signStatus' | 'lastId' | 'pageSize',
    false
  >
>

const act_75352AgentSignRecordPage9376RequestConfig = {
  mockUrl: mockUrl_1_0_0_0,
  path: '/bigo_act_75352_api/act_75352/agent/sign_record_page',
  isYapi: true,
  isC: false,
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_1_0_0_0,
  paramNames: [],
  queryNames: ['bigoId', 'startTime', 'endTime', 'zone', 'activityName', 'signStatus', 'lastId', 'pageSize'],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'act_75352AgentSignRecordPage9376',
}

export const act_75352AgentSignRecordPage9376 = makeRequest<
  Act_75352AgentSignRecordPage9376Request,
  Act_75352AgentSignRecordPage9376Response
>(act_75352AgentSignRecordPage9376RequestConfig)
export const useAct_75352AgentSignRecordPage9376 = makeRequestHook<
  Act_75352AgentSignRecordPage9376Request,
  Act_75352AgentSignRecordPage9376RequestConfig,
  ReturnType<typeof act_75352AgentSignRecordPage9376>
>(act_75352AgentSignRecordPage9376)

export interface Act_75352AgentRoundRecordPage9376Request {
  bigoId?: string
  /**
   * 格式 yyyy-MM-dd hh:mm:ss
   */
  startTime: string
  /**
   * 格式 yyyy-MM-dd hh:mm:ss
   */
  endTime: string
  /**
   * 用户手机电脑的时区, 格式举例-8,-6.5,0,+6.5,+8
   */
  zone: string
  activityName?: string
  signStatus: string
  page: string
  pageSize: string
}

export interface Act_75352AgentRoundRecordPage9376Response {
  total: number
  recordList: {
    id: string
    avatar: string
    nickname: string
    bigoId: string
    activityId: number
    day: string
    activityName: string
    roundStartTime: string
    roundEndTime: string
    roundTimeZone: string
    status: number
    modifiable: number
    reachLimit: boolean
    leftChangeTime: number
  }[]
}
type Act_75352AgentRoundRecordPage9376RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/9376',
    '/bigo_act_75352_api/act_75352/agent/round_record_page',
    'data',
    string,
    'bigoId' | 'startTime' | 'endTime' | 'zone' | 'activityName' | 'signStatus' | 'page' | 'pageSize',
    false
  >
>

const act_75352AgentRoundRecordPage9376RequestConfig = {
  mockUrl: mockUrl_1_0_0_0,
  path: '/bigo_act_75352_api/act_75352/agent/round_record_page',
  isYapi: true,
  isC: false,
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_1_0_0_0,
  paramNames: [],
  queryNames: ['bigoId', 'startTime', 'endTime', 'zone', 'activityName', 'signStatus', 'page', 'pageSize'],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'act_75352AgentRoundRecordPage9376',
}

export const act_75352AgentRoundRecordPage9376 = makeRequest<
  Act_75352AgentRoundRecordPage9376Request,
  Act_75352AgentRoundRecordPage9376Response
>(act_75352AgentRoundRecordPage9376RequestConfig)
export const useAct_75352AgentRoundRecordPage9376 = makeRequestHook<
  Act_75352AgentRoundRecordPage9376Request,
  Act_75352AgentRoundRecordPage9376RequestConfig,
  ReturnType<typeof act_75352AgentRoundRecordPage9376>
>(act_75352AgentRoundRecordPage9376)

export interface Act_75352AgentCancelSign9376Request {
  signId: string
  /**
   * 2343
   */
  activityId: number
}

export interface Act_75352AgentCancelSign9376Response {
  uid: number
  code: number
  roundList: {
    activityName: string
    roundTime: string
    timeZone: string
    day: string
  }[]
}
type Act_75352AgentCancelSign9376RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/9376',
    '/bigo_act_75352_api/act_75352/agent/cancel_sign',
    'data',
    string,
    string,
    false
  >
>

const act_75352AgentCancelSign9376RequestConfig = {
  mockUrl: mockUrl_1_0_0_0,
  path: '/bigo_act_75352_api/act_75352/agent/cancel_sign',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_1_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'act_75352AgentCancelSign9376',
}

export const act_75352AgentCancelSign9376 = makeRequest<
  Act_75352AgentCancelSign9376Request,
  Act_75352AgentCancelSign9376Response
>(act_75352AgentCancelSign9376RequestConfig)
export const useAct_75352AgentCancelSign9376 = makeRequestHook<
  Act_75352AgentCancelSign9376Request,
  Act_75352AgentCancelSign9376RequestConfig,
  ReturnType<typeof act_75352AgentCancelSign9376>
>(act_75352AgentCancelSign9376)

export interface Act_75352AgentCancelRound9376Request {
  activityId: number
  id: string
}

export interface Act_75352AgentCancelRound9376Response {}
type Act_75352AgentCancelRound9376RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/9376',
    '/bigo_act_75352_api/act_75352/agent/cancel_round',
    'data',
    string,
    string,
    false
  >
>

const act_75352AgentCancelRound9376RequestConfig = {
  mockUrl: mockUrl_1_0_0_0,
  path: '/bigo_act_75352_api/act_75352/agent/cancel_round',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_1_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'act_75352AgentCancelRound9376',
}

export const act_75352AgentCancelRound9376 = makeRequest<
  Act_75352AgentCancelRound9376Request,
  Act_75352AgentCancelRound9376Response
>(act_75352AgentCancelRound9376RequestConfig)
export const useAct_75352AgentCancelRound9376 = makeRequestHook<
  Act_75352AgentCancelRound9376Request,
  Act_75352AgentCancelRound9376RequestConfig,
  ReturnType<typeof act_75352AgentCancelRound9376>
>(act_75352AgentCancelRound9376)

export interface Act_75352AgentChangeRound9376Request {
  actId: number
  id: string
  day: string
  roundTime: string
}

export interface Act_75352AgentChangeRound9376Response {}
type Act_75352AgentChangeRound9376RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/9376',
    '/bigo_act_75352_api/act_75352/agent/change_round',
    'data',
    string,
    string,
    false
  >
>

const act_75352AgentChangeRound9376RequestConfig = {
  mockUrl: mockUrl_1_0_0_0,
  path: '/bigo_act_75352_api/act_75352/agent/change_round',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_1_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'act_75352AgentChangeRound9376',
}

export const act_75352AgentChangeRound9376 = makeRequest<
  Act_75352AgentChangeRound9376Request,
  Act_75352AgentChangeRound9376Response
>(act_75352AgentChangeRound9376RequestConfig)
export const useAct_75352AgentChangeRound9376 = makeRequestHook<
  Act_75352AgentChangeRound9376Request,
  Act_75352AgentChangeRound9376RequestConfig,
  ReturnType<typeof act_75352AgentChangeRound9376>
>(act_75352AgentChangeRound9376)

export interface Act_75352AgentChangeAnchor9376Request {
  actId: number
  id: string
  newBigoId: string
}

export interface Act_75352AgentChangeAnchor9376Response {}
type Act_75352AgentChangeAnchor9376RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/9376',
    '/bigo_act_75352_api/act_75352/agent/change_anchor',
    'data',
    string,
    string,
    false
  >
>

const act_75352AgentChangeAnchor9376RequestConfig = {
  mockUrl: mockUrl_1_0_0_0,
  path: '/bigo_act_75352_api/act_75352/agent/change_anchor',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_1_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'act_75352AgentChangeAnchor9376',
}

export const act_75352AgentChangeAnchor9376 = makeRequest<
  Act_75352AgentChangeAnchor9376Request,
  Act_75352AgentChangeAnchor9376Response
>(act_75352AgentChangeAnchor9376RequestConfig)
export const useAct_75352AgentChangeAnchor9376 = makeRequestHook<
  Act_75352AgentChangeAnchor9376Request,
  Act_75352AgentChangeAnchor9376RequestConfig,
  ReturnType<typeof act_75352AgentChangeAnchor9376>
>(act_75352AgentChangeAnchor9376)

export interface Act_75352AgentSignExport9376Request {
  traceId: string
  userUid: number
  mail: string
  bigoId: string
  startTime: number
  endTime: number
  activityName: string
  signStatus: number
}

export interface Act_75352AgentSignExport9376Response {}
type Act_75352AgentSignExport9376RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/9376',
    '/bigo_act_75352_api/act_75352/agent/sign_export',
    'data',
    string,
    string,
    false
  >
>

const act_75352AgentSignExport9376RequestConfig = {
  mockUrl: mockUrl_1_0_0_0,
  path: '/bigo_act_75352_api/act_75352/agent/sign_export',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_1_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'act_75352AgentSignExport9376',
}

export const act_75352AgentSignExport9376 = makeRequest<
  Act_75352AgentSignExport9376Request,
  Act_75352AgentSignExport9376Response
>(act_75352AgentSignExport9376RequestConfig)
export const useAct_75352AgentSignExport9376 = makeRequestHook<
  Act_75352AgentSignExport9376Request,
  Act_75352AgentSignExport9376RequestConfig,
  ReturnType<typeof act_75352AgentSignExport9376>
>(act_75352AgentSignExport9376)

export interface Act_75352AgentRoundExport9376Request {
  traceId: string
  userUid: number
  mail: string
  bigoId: string
  startTime: number
  endTime: number
  activityName: string
  signStatus: number
}

export interface Act_75352AgentRoundExport9376Response {}
type Act_75352AgentRoundExport9376RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/9376',
    '/bigo_act_75352_api/act_75352/agent/round_export',
    'data',
    string,
    string,
    false
  >
>

const act_75352AgentRoundExport9376RequestConfig = {
  mockUrl: mockUrl_1_0_0_0,
  path: '/bigo_act_75352_api/act_75352/agent/round_export',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_1_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'act_75352AgentRoundExport9376',
}

export const act_75352AgentRoundExport9376 = makeRequest<
  Act_75352AgentRoundExport9376Request,
  Act_75352AgentRoundExport9376Response
>(act_75352AgentRoundExport9376RequestConfig)
export const useAct_75352AgentRoundExport9376 = makeRequestHook<
  Act_75352AgentRoundExport9376Request,
  Act_75352AgentRoundExport9376RequestConfig,
  ReturnType<typeof act_75352AgentRoundExport9376>
>(act_75352AgentRoundExport9376)

export interface Act_75352AgentSignActList9376Request {
  activityName?: string
  month: string
  status?: string
  page?: string
  size?: string
  /**
   * 手机/电脑时区，格式6.5, 6, 0, -6.5, -6
   */
  zone: string
}

export interface Act_75352AgentSignActList9376Response {
  total: string
  list: {
    status: number
    activityId: number
    activityName: string
    activityDesc: string
    activityImage: string
    startTime: string
    endTime: string
    timeZone: string
    answerInfos: {
      key: string
    }
    actStartCountdown: number
    alreadySignedPeopleCount: number
    dayRoundLimitCount: number
  }[]
}
type Act_75352AgentSignActList9376RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/9376',
    '/bigo_act_75352_api/act_75352/agent/sign_act_list',
    'data',
    string,
    'activityName' | 'month' | 'status' | 'page' | 'size' | 'zone',
    false
  >
>

const act_75352AgentSignActList9376RequestConfig = {
  mockUrl: mockUrl_1_0_0_0,
  path: '/bigo_act_75352_api/act_75352/agent/sign_act_list',
  isYapi: true,
  isC: false,
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_1_0_0_0,
  paramNames: [],
  queryNames: ['activityName', 'month', 'status', 'page', 'size', 'zone'],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'act_75352AgentSignActList9376',
}

export const act_75352AgentSignActList9376 = makeRequest<
  Act_75352AgentSignActList9376Request,
  Act_75352AgentSignActList9376Response
>(act_75352AgentSignActList9376RequestConfig)
export const useAct_75352AgentSignActList9376 = makeRequestHook<
  Act_75352AgentSignActList9376Request,
  Act_75352AgentSignActList9376RequestConfig,
  ReturnType<typeof act_75352AgentSignActList9376>
>(act_75352AgentSignActList9376)

export interface Act_75352AgentSignStatusCountInfo9376Request {
  activityName?: string
  month: string
  zone: string
}

export interface Act_75352AgentSignStatusCountInfo9376Response {
  statusInfos: {
    key: number
  }
}
type Act_75352AgentSignStatusCountInfo9376RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/9376',
    '/bigo_act_75352_api/act_75352/agent/sign_status_count_info',
    'data',
    string,
    'activityName' | 'month' | 'zone',
    false
  >
>

const act_75352AgentSignStatusCountInfo9376RequestConfig = {
  mockUrl: mockUrl_1_0_0_0,
  path: '/bigo_act_75352_api/act_75352/agent/sign_status_count_info',
  isYapi: true,
  isC: false,
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_1_0_0_0,
  paramNames: [],
  queryNames: ['activityName', 'month', 'zone'],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'act_75352AgentSignStatusCountInfo9376',
}

export const act_75352AgentSignStatusCountInfo9376 = makeRequest<
  Act_75352AgentSignStatusCountInfo9376Request,
  Act_75352AgentSignStatusCountInfo9376Response
>(act_75352AgentSignStatusCountInfo9376RequestConfig)
export const useAct_75352AgentSignStatusCountInfo9376 = makeRequestHook<
  Act_75352AgentSignStatusCountInfo9376Request,
  Act_75352AgentSignStatusCountInfo9376RequestConfig,
  ReturnType<typeof act_75352AgentSignStatusCountInfo9376>
>(act_75352AgentSignStatusCountInfo9376)

export interface Act_75352AgentSignActFormInfo9376Request {
  activityId: string
}

export interface Act_75352AgentSignActFormInfo9376Response {
  version: number
  questionInfoList: {
    id: number
    type: number
    title: string
    isRequired: number
    hasOtherOptions: number
    options:
      | []
      | [
          {
            num: number
            content: string
          },
        ]
    dayRows: [] | [string]
    timeColumns: [] | [string]
    anchorLimit: number
    stageLimit: number
    signCount: string
  }[]
  actInfo: {
    status: number
    activityId: number
    activityName: string
    activityDesc: string
    activityImage: string
    startTime: string
    endTime: string
    timeZone: string
    answerInfos: {
      key: string
    }
    actStartCountdown: number
    alreadySignedPeopleCount: number
    dayRoundLimitCount: number
  }
}
type Act_75352AgentSignActFormInfo9376RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/9376',
    '/bigo_act_75352_api/act_75352/agent/sign_act_form_info',
    'data',
    string,
    'activityId',
    false
  >
>

const act_75352AgentSignActFormInfo9376RequestConfig = {
  mockUrl: mockUrl_1_0_0_0,
  path: '/bigo_act_75352_api/act_75352/agent/sign_act_form_info',
  isYapi: true,
  isC: false,
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_1_0_0_0,
  paramNames: [],
  queryNames: ['activityId'],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'act_75352AgentSignActFormInfo9376',
}

export const act_75352AgentSignActFormInfo9376 = makeRequest<
  Act_75352AgentSignActFormInfo9376Request,
  Act_75352AgentSignActFormInfo9376Response
>(act_75352AgentSignActFormInfo9376RequestConfig)
export const useAct_75352AgentSignActFormInfo9376 = makeRequestHook<
  Act_75352AgentSignActFormInfo9376Request,
  Act_75352AgentSignActFormInfo9376RequestConfig,
  ReturnType<typeof act_75352AgentSignActFormInfo9376>
>(act_75352AgentSignActFormInfo9376)

export interface Act_75352AgentEntrance9376Request {}

export interface Act_75352AgentEntrance9376Response {
  hasEntrance: boolean
}
type Act_75352AgentEntrance9376RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/9376',
    '/bigo_act_75352_api/act_75352/agent/entrance',
    'data',
    string,
    string,
    true
  >
>

const act_75352AgentEntrance9376RequestConfig = {
  mockUrl: mockUrl_1_0_0_0,
  path: '/bigo_act_75352_api/act_75352/agent/entrance',
  isYapi: true,
  isC: false,
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_1_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'act_75352AgentEntrance9376',
}

export const act_75352AgentEntrance9376 = makeRequest<
  Act_75352AgentEntrance9376Request,
  Act_75352AgentEntrance9376Response
>(act_75352AgentEntrance9376RequestConfig)
export const useAct_75352AgentEntrance9376 = makeRequestHook<
  Act_75352AgentEntrance9376Request,
  Act_75352AgentEntrance9376RequestConfig,
  ReturnType<typeof act_75352AgentEntrance9376>
>(act_75352AgentEntrance9376)

export interface Act_75352AgentAsyncSignResult9376Request {
  id: string
}

export interface Act_75352AgentAsyncSignResult9376Response {
  multiActReminders: {
    bigoId: string
    activityName: string
    actId: number
    roundTime: string
  }[]
  failedList: {
    failCode: number
    bigoId: string
    date: string
    roundTime: string
  }[]
  successCount: number
}
type Act_75352AgentAsyncSignResult9376RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/9376',
    '/bigo_act_75352_api/act_75352/agent/async_sign_result',
    'data',
    string,
    string,
    false
  >
>

const act_75352AgentAsyncSignResult9376RequestConfig = {
  mockUrl: mockUrl_1_0_0_0,
  path: '/bigo_act_75352_api/act_75352/agent/async_sign_result',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_1_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'act_75352AgentAsyncSignResult9376',
}

export const act_75352AgentAsyncSignResult9376 = makeRequest<
  Act_75352AgentAsyncSignResult9376Request,
  Act_75352AgentAsyncSignResult9376Response
>(act_75352AgentAsyncSignResult9376RequestConfig)
export const useAct_75352AgentAsyncSignResult9376 = makeRequestHook<
  Act_75352AgentAsyncSignResult9376Request,
  Act_75352AgentAsyncSignResult9376RequestConfig,
  ReturnType<typeof act_75352AgentAsyncSignResult9376>
>(act_75352AgentAsyncSignResult9376)

export interface Act_75352ApiAgentGetChangePageInfo9376Request {
  roundId?: string
  activityId: string
}

export interface Act_75352ApiAgentGetChangePageInfo9376Response {
  activityId: number
  activityName: string
  activityDesc: string
  activityImage: string
  originTime: string
  day: string
  timeColumns: string[]
}
type Act_75352ApiAgentGetChangePageInfo9376RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/9376',
    '/bigo_act_75352_api/act_75352/api/agent/getChangePageInfo',
    'data',
    string,
    'roundId' | 'activityId',
    false
  >
>

const act_75352ApiAgentGetChangePageInfo9376RequestConfig = {
  mockUrl: mockUrl_1_0_0_0,
  path: '/bigo_act_75352_api/act_75352/api/agent/getChangePageInfo',
  isYapi: true,
  isC: false,
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_1_0_0_0,
  paramNames: [],
  queryNames: ['roundId', 'activityId'],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'act_75352ApiAgentGetChangePageInfo9376',
}

export const act_75352ApiAgentGetChangePageInfo9376 = makeRequest<
  Act_75352ApiAgentGetChangePageInfo9376Request,
  Act_75352ApiAgentGetChangePageInfo9376Response
>(act_75352ApiAgentGetChangePageInfo9376RequestConfig)
export const useAct_75352ApiAgentGetChangePageInfo9376 = makeRequestHook<
  Act_75352ApiAgentGetChangePageInfo9376Request,
  Act_75352ApiAgentGetChangePageInfo9376RequestConfig,
  ReturnType<typeof act_75352ApiAgentGetChangePageInfo9376>
>(act_75352ApiAgentGetChangePageInfo9376)

export interface Act_75352ApiAgentCanChangeRound9376Request {
  /**
   * 1000
   */
  actId: number
  roundId: string
}

export type Act_75352ApiAgentCanChangeRound9376Response = boolean
type Act_75352ApiAgentCanChangeRound9376RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/9376',
    '/bigo_act_75352_api/act_75352/api/agent/canChangeRound',
    'data',
    string,
    string,
    false
  >
>

const act_75352ApiAgentCanChangeRound9376RequestConfig = {
  mockUrl: mockUrl_1_0_0_0,
  path: '/bigo_act_75352_api/act_75352/api/agent/canChangeRound',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_1_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'act_75352ApiAgentCanChangeRound9376',
}

export const act_75352ApiAgentCanChangeRound9376 = makeRequest<
  Act_75352ApiAgentCanChangeRound9376Request,
  Act_75352ApiAgentCanChangeRound9376Response
>(act_75352ApiAgentCanChangeRound9376RequestConfig)
export const useAct_75352ApiAgentCanChangeRound9376 = makeRequestHook<
  Act_75352ApiAgentCanChangeRound9376Request,
  Act_75352ApiAgentCanChangeRound9376RequestConfig,
  ReturnType<typeof act_75352ApiAgentCanChangeRound9376>
>(act_75352ApiAgentCanChangeRound9376)

export interface AgentSignActList9376Request {
  activityName?: string
  month: string
  zone: string
  status?: string
  page?: string
  size?: string
}

export interface AgentSignActList9376Response {
  list: {
    status: number
    activityId: number
    activityName: string
    activityDesc: string
    activityImage: string
    startTime: string
    endTime: string
    timeZone: string
    answerInfos: {
      key: string
    }
    actStartCountdown: number
    alreadySignedPeopleCount: number
    dayRoundLimitCount: number
  }[]
  total: number
}
type AgentSignActList9376RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/9376',
    '/act_75352/agent/sign_act_list',
    'data',
    string,
    'activityName' | 'month' | 'zone' | 'status' | 'page' | 'size',
    false
  >
>

const agentSignActList9376RequestConfig = {
  mockUrl: mockUrl_1_0_0_0,
  path: '/act_75352/agent/sign_act_list',
  isYapi: true,
  isC: false,
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_1_0_0_0,
  paramNames: [],
  queryNames: ['activityName', 'month', 'zone', 'status', 'page', 'size'],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'agentSignActList9376',
}

export const agentSignActList9376 = makeRequest<AgentSignActList9376Request, AgentSignActList9376Response>(
  agentSignActList9376RequestConfig,
)
export const useAgentSignActList9376 = makeRequestHook<
  AgentSignActList9376Request,
  AgentSignActList9376RequestConfig,
  ReturnType<typeof agentSignActList9376>
>(agentSignActList9376)

export interface AgentSignActFormInfo9376Request {
  activityId: string
}

export interface AgentSignActFormInfo9376Response {
  version: number
  signPeopleCountMap: {
    key: number
  }
  questionInfoList: {
    id: string
    type: number
    title: string
    isRequired: number
    hasOtherOptions: number
    options:
      | []
      | [
          {
            num: number
            content: string
          },
        ]
    dayRows: [] | [string]
    timeColumns: [] | [string]
    anchorLimit: number
    stageLimit: number
    signCount: string
  }[]
  actInfo: {
    status: number
    activityId: number
    activityName: string
    activityDesc: string
    activityImage: string
    startTime: string
    endTime: string
    timeZone: string
    answerInfos: {
      key: string
    }
    actStartCountdown: number
    alreadySignedPeopleCount: number
    dayRoundLimitCount: number
  }
}
type AgentSignActFormInfo9376RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/9376',
    '/act_75352/agent/sign_act_form_info',
    'data',
    string,
    'activityId',
    false
  >
>

const agentSignActFormInfo9376RequestConfig = {
  mockUrl: mockUrl_1_0_0_0,
  path: '/act_75352/agent/sign_act_form_info',
  isYapi: true,
  isC: false,
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_1_0_0_0,
  paramNames: [],
  queryNames: ['activityId'],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'agentSignActFormInfo9376',
}

export const agentSignActFormInfo9376 = makeRequest<AgentSignActFormInfo9376Request, AgentSignActFormInfo9376Response>(
  agentSignActFormInfo9376RequestConfig,
)
export const useAgentSignActFormInfo9376 = makeRequestHook<
  AgentSignActFormInfo9376Request,
  AgentSignActFormInfo9376RequestConfig,
  ReturnType<typeof agentSignActFormInfo9376>
>(agentSignActFormInfo9376)

export interface AgentSignStatusCountInfo9376Request {
  activityName?: string
  month: string
  zone: string
}

export interface AgentSignStatusCountInfo9376Response {
  statusInfos: {
    key: number
  }
}
type AgentSignStatusCountInfo9376RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/9376',
    '/act_75352/agent/sign_status_count_info',
    'data',
    string,
    'activityName' | 'month' | 'zone',
    false
  >
>

const agentSignStatusCountInfo9376RequestConfig = {
  mockUrl: mockUrl_1_0_0_0,
  path: '/act_75352/agent/sign_status_count_info',
  isYapi: true,
  isC: false,
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_1_0_0_0,
  paramNames: [],
  queryNames: ['activityName', 'month', 'zone'],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'agentSignStatusCountInfo9376',
}

export const agentSignStatusCountInfo9376 = makeRequest<
  AgentSignStatusCountInfo9376Request,
  AgentSignStatusCountInfo9376Response
>(agentSignStatusCountInfo9376RequestConfig)
export const useAgentSignStatusCountInfo9376 = makeRequestHook<
  AgentSignStatusCountInfo9376Request,
  AgentSignStatusCountInfo9376RequestConfig,
  ReturnType<typeof agentSignStatusCountInfo9376>
>(agentSignStatusCountInfo9376)

export interface AgentQueryAnchorList9376Request {
  activityId: string
  anchorBigoId?: string
  pageIndex: string
  pageSize: string
}

export interface AgentQueryAnchorList9376Response {
  list: {
    uid: number
    id: string
    nickName: string
    avatar: string
    signStatus: number
  }[]
  total: number
}
type AgentQueryAnchorList9376RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/9376',
    '/act_75352/agent/query_anchor_list',
    'data',
    string,
    'activityId' | 'anchorBigoId' | 'pageIndex' | 'pageSize',
    false
  >
>

const agentQueryAnchorList9376RequestConfig = {
  mockUrl: mockUrl_1_0_0_0,
  path: '/act_75352/agent/query_anchor_list',
  isYapi: true,
  isC: false,
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_1_0_0_0,
  paramNames: [],
  queryNames: ['activityId', 'anchorBigoId', 'pageIndex', 'pageSize'],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'agentQueryAnchorList9376',
}

export const agentQueryAnchorList9376 = makeRequest<AgentQueryAnchorList9376Request, AgentQueryAnchorList9376Response>(
  agentQueryAnchorList9376RequestConfig,
)
export const useAgentQueryAnchorList9376 = makeRequestHook<
  AgentQueryAnchorList9376Request,
  AgentQueryAnchorList9376RequestConfig,
  ReturnType<typeof agentQueryAnchorList9376>
>(agentQueryAnchorList9376)

export interface AgentSign9376Request {
  type: number
  activityId: number
  version: number
  /**
   * [""]
   */
  bigoIdList: string[]
  answerInfos: {
    key: string
  }
  /**
   * [{"id":"","type":0,"title":"","isRequired":0,"hasOtherOptions":0,"options":[{"num":0,"content":""}],"dayRows":[""],"timeColumns":[""],"anchorLimit":0,"stageLimit":0}]
   */
  questions: {
    id: string
    type: number
    title: string
    isRequired: number
    hasOtherOptions: number
    /**
     * [{"num":0,"content":""}]
     */
    options: {
      num: number
      content: string
    }[]
    /**
     * [""]
     */
    dayRows: string[]
    /**
     * [""]
     */
    timeColumns: string[]
    anchorLimit: number
    stageLimit: number
  }[]
}

export interface AgentSign9376Response {
  id: string
  multiActReminders: {
    bigoId: string
    activityName: string
    actId: number
    roundTime: string
  }[]
  failedList: {
    failCode: number
    bigoId: string
    date: string
    roundTime: string
  }[]
  successCount: number
}
type AgentSign9376RequestConfig = Readonly<
  RequestConfig<'http://yapi.ppx520.com/mock/9376', '/act_75352/agent/sign', 'data', string, string, false>
>

const agentSign9376RequestConfig = {
  mockUrl: mockUrl_1_0_0_0,
  path: '/act_75352/agent/sign',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_1_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'agentSign9376',
}

export const agentSign9376 = makeRequest<AgentSign9376Request, AgentSign9376Response>(agentSign9376RequestConfig)
export const useAgentSign9376 = makeRequestHook<
  AgentSign9376Request,
  AgentSign9376RequestConfig,
  ReturnType<typeof agentSign9376>
>(agentSign9376)

export interface AgentSignRecordPage9376Request {
  bigoId?: string
  /**
   * 格式 yyyy-MM-dd hh:mm:ss
   */
  startTime: string
  /**
   * 格式 yyyy-MM-dd hh:mm:ss
   */
  endTime: string
  /**
   * 用户手机电脑的时区, 格式举例-8,-6.5,0,+6.5,+8
   */
  zone: string
  activityName?: string
  signStatus?: string
  lastId?: string
  pageSize: string
}

export interface AgentSignRecordPage9376Response {
  lastId: string
  total: number
  recordList: {
    id: string
    avatar: string
    nickname: string
    bigoId: string
    roundTimeZone: string
    activityId: number
    signTime: number
    actStartTime: string
    actEndTime: string
    activityName: string
    roundItems:
      | []
      | [
          {
            roundStartTime: string
            roundEndTime: string
            roundTimeZone: string
          },
        ]
    status: number
  }[]
}
type AgentSignRecordPage9376RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/9376',
    '/act_75352/agent/sign_record_page',
    'data',
    string,
    'bigoId' | 'startTime' | 'endTime' | 'zone' | 'activityName' | 'signStatus' | 'lastId' | 'pageSize',
    false
  >
>

const agentSignRecordPage9376RequestConfig = {
  mockUrl: mockUrl_1_0_0_0,
  path: '/act_75352/agent/sign_record_page',
  isYapi: true,
  isC: false,
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_1_0_0_0,
  paramNames: [],
  queryNames: ['bigoId', 'startTime', 'endTime', 'zone', 'activityName', 'signStatus', 'lastId', 'pageSize'],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'agentSignRecordPage9376',
}

export const agentSignRecordPage9376 = makeRequest<AgentSignRecordPage9376Request, AgentSignRecordPage9376Response>(
  agentSignRecordPage9376RequestConfig,
)
export const useAgentSignRecordPage9376 = makeRequestHook<
  AgentSignRecordPage9376Request,
  AgentSignRecordPage9376RequestConfig,
  ReturnType<typeof agentSignRecordPage9376>
>(agentSignRecordPage9376)

export interface AgentCancelSign9376Request {
  signId: string
  activityId: number
}

export interface AgentCancelSign9376Response {
  uid: number
  code: number
  roundList: {
    activityName: string
    roundTime: string
    timeZone: string
    day: string
    roundStartTime: number
  }[]
}
type AgentCancelSign9376RequestConfig = Readonly<
  RequestConfig<'http://yapi.ppx520.com/mock/9376', '/act_75352/agent/cancel_sign', 'data', string, string, false>
>

const agentCancelSign9376RequestConfig = {
  mockUrl: mockUrl_1_0_0_0,
  path: '/act_75352/agent/cancel_sign',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_1_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'agentCancelSign9376',
}

export const agentCancelSign9376 = makeRequest<AgentCancelSign9376Request, AgentCancelSign9376Response>(
  agentCancelSign9376RequestConfig,
)
export const useAgentCancelSign9376 = makeRequestHook<
  AgentCancelSign9376Request,
  AgentCancelSign9376RequestConfig,
  ReturnType<typeof agentCancelSign9376>
>(agentCancelSign9376)

export interface AgentSignExport9376Request {
  traceId: string
  userUid: number
  /**
   * "@pick([0,1,2])"
   */
  roleType: string
  mail: string
  bigoId: string
  startTime: string
  endTime: string
  zone: string
  activityName: string
  signStatus: number
}

export type AgentSignExport9376Response = boolean
type AgentSignExport9376RequestConfig = Readonly<
  RequestConfig<'http://yapi.ppx520.com/mock/9376', '/act_75352/agent/sign_export', 'data', string, string, false>
>

const agentSignExport9376RequestConfig = {
  mockUrl: mockUrl_1_0_0_0,
  path: '/act_75352/agent/sign_export',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_1_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'agentSignExport9376',
}

export const agentSignExport9376 = makeRequest<AgentSignExport9376Request, AgentSignExport9376Response>(
  agentSignExport9376RequestConfig,
)
export const useAgentSignExport9376 = makeRequestHook<
  AgentSignExport9376Request,
  AgentSignExport9376RequestConfig,
  ReturnType<typeof agentSignExport9376>
>(agentSignExport9376)

export interface AgentRoundRecordPage9376Request {
  bigoId?: string
  /**
   * 格式 yyyy-MM-dd hh:mm:ss
   */
  startTime: string
  /**
   * 格式 yyyy-MM-dd hh:mm:ss
   */
  endTime: string
  /**
   * 用户手机电脑的时区, 格式举例-8,-6.5,0,+6.5,+8
   */
  zone: string
  activityName?: string
  signStatus?: string
}

export interface AgentRoundRecordPage9376Response {
  total: number
  recordList: {
    id: string
    avatar: string
    nickname: string
    bigoId: string
    activityId: number
    activityName: string
    day: string
    roundStartTime: string
    roundEndTime: string
    roundTimeZone: string
    status: number
    modifiable: number
    reachLimit: boolean
    leftChangeTime: number
  }[]
}
type AgentRoundRecordPage9376RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/9376',
    '/act_75352/agent/round_record_page',
    'data',
    string,
    'bigoId' | 'startTime' | 'endTime' | 'zone' | 'activityName' | 'signStatus',
    false
  >
>

const agentRoundRecordPage9376RequestConfig = {
  mockUrl: mockUrl_1_0_0_0,
  path: '/act_75352/agent/round_record_page',
  isYapi: true,
  isC: false,
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_1_0_0_0,
  paramNames: [],
  queryNames: ['bigoId', 'startTime', 'endTime', 'zone', 'activityName', 'signStatus'],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'agentRoundRecordPage9376',
}

export const agentRoundRecordPage9376 = makeRequest<AgentRoundRecordPage9376Request, AgentRoundRecordPage9376Response>(
  agentRoundRecordPage9376RequestConfig,
)
export const useAgentRoundRecordPage9376 = makeRequestHook<
  AgentRoundRecordPage9376Request,
  AgentRoundRecordPage9376RequestConfig,
  ReturnType<typeof agentRoundRecordPage9376>
>(agentRoundRecordPage9376)

export interface AgentCancelRound9376Request {
  activityId: number
  id: string
}

export type AgentCancelRound9376Response = boolean
type AgentCancelRound9376RequestConfig = Readonly<
  RequestConfig<'http://yapi.ppx520.com/mock/9376', '/act_75352/agent/cancel_round', 'data', string, string, false>
>

const agentCancelRound9376RequestConfig = {
  mockUrl: mockUrl_1_0_0_0,
  path: '/act_75352/agent/cancel_round',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_1_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'agentCancelRound9376',
}

export const agentCancelRound9376 = makeRequest<AgentCancelRound9376Request, AgentCancelRound9376Response>(
  agentCancelRound9376RequestConfig,
)
export const useAgentCancelRound9376 = makeRequestHook<
  AgentCancelRound9376Request,
  AgentCancelRound9376RequestConfig,
  ReturnType<typeof agentCancelRound9376>
>(agentCancelRound9376)

export interface AgentChangeRound9376Request {
  actId: number
  id: string
  day: string
  roundTime: string
}

export type AgentChangeRound9376Response = boolean
type AgentChangeRound9376RequestConfig = Readonly<
  RequestConfig<'http://yapi.ppx520.com/mock/9376', '/act_75352/agent/change_round', 'data', string, string, false>
>

const agentChangeRound9376RequestConfig = {
  mockUrl: mockUrl_1_0_0_0,
  path: '/act_75352/agent/change_round',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_1_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'agentChangeRound9376',
}

export const agentChangeRound9376 = makeRequest<AgentChangeRound9376Request, AgentChangeRound9376Response>(
  agentChangeRound9376RequestConfig,
)
export const useAgentChangeRound9376 = makeRequestHook<
  AgentChangeRound9376Request,
  AgentChangeRound9376RequestConfig,
  ReturnType<typeof agentChangeRound9376>
>(agentChangeRound9376)

export interface AgentChangeAnchor9376Request {
  actId: number
  id: string
  newBigoId: string
}

export interface AgentChangeAnchor9376Response {}
type AgentChangeAnchor9376RequestConfig = Readonly<
  RequestConfig<'http://yapi.ppx520.com/mock/9376', '/act_75352/agent/change_anchor', 'data', string, string, false>
>

const agentChangeAnchor9376RequestConfig = {
  mockUrl: mockUrl_1_0_0_0,
  path: '/act_75352/agent/change_anchor',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_1_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'agentChangeAnchor9376',
}

export const agentChangeAnchor9376 = makeRequest<AgentChangeAnchor9376Request, AgentChangeAnchor9376Response>(
  agentChangeAnchor9376RequestConfig,
)
export const useAgentChangeAnchor9376 = makeRequestHook<
  AgentChangeAnchor9376Request,
  AgentChangeAnchor9376RequestConfig,
  ReturnType<typeof agentChangeAnchor9376>
>(agentChangeAnchor9376)

export interface AgentRoundExport9376Request {
  traceId: string
  userUid: number
  /**
   * "@pick([0,1,2])"
   */
  roleType: string
  mail: string
  bigoId: string
  startTime: string
  endTime: string
  zone: string
  activityName: string
  signStatus: number
}

export type AgentRoundExport9376Response = boolean
type AgentRoundExport9376RequestConfig = Readonly<
  RequestConfig<'http://yapi.ppx520.com/mock/9376', '/act_75352/agent/round_export', 'data', string, string, false>
>

const agentRoundExport9376RequestConfig = {
  mockUrl: mockUrl_1_0_0_0,
  path: '/act_75352/agent/round_export',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_1_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'agentRoundExport9376',
}

export const agentRoundExport9376 = makeRequest<AgentRoundExport9376Request, AgentRoundExport9376Response>(
  agentRoundExport9376RequestConfig,
)
export const useAgentRoundExport9376 = makeRequestHook<
  AgentRoundExport9376Request,
  AgentRoundExport9376RequestConfig,
  ReturnType<typeof agentRoundExport9376>
>(agentRoundExport9376)

export interface AgentEntrance9376Request {}

export interface AgentEntrance9376Response {
  hasEntrance: boolean
}
type AgentEntrance9376RequestConfig = Readonly<
  RequestConfig<'http://yapi.ppx520.com/mock/9376', '/act_75352/agent/entrance', 'data', string, string, true>
>

const agentEntrance9376RequestConfig = {
  mockUrl: mockUrl_1_0_0_0,
  path: '/act_75352/agent/entrance',
  isYapi: true,
  isC: false,
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_1_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'agentEntrance9376',
}

export const agentEntrance9376 = makeRequest<AgentEntrance9376Request, AgentEntrance9376Response>(
  agentEntrance9376RequestConfig,
)
export const useAgentEntrance9376 = makeRequestHook<
  AgentEntrance9376Request,
  AgentEntrance9376RequestConfig,
  ReturnType<typeof agentEntrance9376>
>(agentEntrance9376)

export interface AgentEntranceByPost9376Request {}

export interface AgentEntranceByPost9376Response {
  hasEntrance: boolean
}
type AgentEntranceByPost9376RequestConfig = Readonly<
  RequestConfig<'http://yapi.ppx520.com/mock/9376', '/act_75352/agent/entranceByPost', 'data', string, string, true>
>

const agentEntranceByPost9376RequestConfig = {
  mockUrl: mockUrl_1_0_0_0,
  path: '/act_75352/agent/entranceByPost',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.none,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_1_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'agentEntranceByPost9376',
}

export const agentEntranceByPost9376 = makeRequest<AgentEntranceByPost9376Request, AgentEntranceByPost9376Response>(
  agentEntranceByPost9376RequestConfig,
)
export const useAgentEntranceByPost9376 = makeRequestHook<
  AgentEntranceByPost9376Request,
  AgentEntranceByPost9376RequestConfig,
  ReturnType<typeof agentEntranceByPost9376>
>(agentEntranceByPost9376)

export interface AgentAsyncSignResult9376Request {
  id: number
}

export interface AgentAsyncSignResult9376Response {
  id: string
  multiActReminders: {
    bigoId: string
    activityName: string
    actId: number
    roundTime: string
  }[]
  failedList: {
    failCode: number
    bigoId: string
    date: string
    roundTime: string
  }[]
  successCount: number
}
type AgentAsyncSignResult9376RequestConfig = Readonly<
  RequestConfig<'http://yapi.ppx520.com/mock/9376', '/act_75352/agent/async_sign_result', 'data', string, string, false>
>

const agentAsyncSignResult9376RequestConfig = {
  mockUrl: mockUrl_1_0_0_0,
  path: '/act_75352/agent/async_sign_result',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_1_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'agentAsyncSignResult9376',
}

export const agentAsyncSignResult9376 = makeRequest<AgentAsyncSignResult9376Request, AgentAsyncSignResult9376Response>(
  agentAsyncSignResult9376RequestConfig,
)
export const useAgentAsyncSignResult9376 = makeRequestHook<
  AgentAsyncSignResult9376Request,
  AgentAsyncSignResult9376RequestConfig,
  ReturnType<typeof agentAsyncSignResult9376>
>(agentAsyncSignResult9376)

export interface AgentCanChangeRound9376Request {
  actId: number
  roundId: string
}

export type AgentCanChangeRound9376Response = boolean
type AgentCanChangeRound9376RequestConfig = Readonly<
  RequestConfig<'http://yapi.ppx520.com/mock/9376', '/act_75352/agent/canChangeRound', 'data', string, string, false>
>

const agentCanChangeRound9376RequestConfig = {
  mockUrl: mockUrl_1_0_0_0,
  path: '/act_75352/agent/canChangeRound',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_1_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'agentCanChangeRound9376',
}

export const agentCanChangeRound9376 = makeRequest<AgentCanChangeRound9376Request, AgentCanChangeRound9376Response>(
  agentCanChangeRound9376RequestConfig,
)
export const useAgentCanChangeRound9376 = makeRequestHook<
  AgentCanChangeRound9376Request,
  AgentCanChangeRound9376RequestConfig,
  ReturnType<typeof agentCanChangeRound9376>
>(agentCanChangeRound9376)

export interface AgentGetChangePageInfo9376Request {
  roundId?: string
  activityId?: string
}

export interface AgentGetChangePageInfo9376Response {
  activityId: number
  activityName: string
  activityDesc: string
  activityImage: string
  originTime: string
  day: string
  timeColumns: string[]
}
type AgentGetChangePageInfo9376RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/9376',
    '/act_75352/agent/getChangePageInfo',
    'data',
    string,
    'roundId' | 'activityId',
    false
  >
>

const agentGetChangePageInfo9376RequestConfig = {
  mockUrl: mockUrl_1_0_0_0,
  path: '/act_75352/agent/getChangePageInfo',
  isYapi: true,
  isC: false,
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_1_0_0_0,
  paramNames: [],
  queryNames: ['roundId', 'activityId'],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'agentGetChangePageInfo9376',
}

export const agentGetChangePageInfo9376 = makeRequest<
  AgentGetChangePageInfo9376Request,
  AgentGetChangePageInfo9376Response
>(agentGetChangePageInfo9376RequestConfig)
export const useAgentGetChangePageInfo9376 = makeRequestHook<
  AgentGetChangePageInfo9376Request,
  AgentGetChangePageInfo9376RequestConfig,
  ReturnType<typeof agentGetChangePageInfo9376>
>(agentGetChangePageInfo9376)

/* prettier-ignore-end */
